export default __webpack_public_path__ + "78a119056f87d723f6673cf4b761d3cc.png";